import React, { useState } from 'react';
import { TCustomTableProps } from './CustomTable.type';
import { getFormatedDateTime } from '../../../Utils/DateUtils';
import './CustomTable.scss';

const CustomTable = (props: TCustomTableProps) => {
  const {
    data,
    tableLabel,
    tableLabelActionBtnVisibility = false,
    additionalClass,
    tableColumnTitle,
    modalView,
    callback,
    link,
  } = props;
  const [showTableContent, setshowTableContent] = useState(false);

  return (
    <div className={`CustomTable ${additionalClass} ${link ? 'footer-visible' : ''}`}>
      {tableLabel && tableLabel !== '' && (
        <div className="Table_Action">
          {!modalView && (
            <div className="Table_Header_Row">
              <span>{tableLabel}</span>
              <span>
                {link && (
                  <a href={link} target="_blank" rel="noopener noreferrer" className="table-link">
                    <img src="/oo/assets/icon/submit-file.svg" alt="No Data" /> Request a Reference
                  </a>
                )}
              </span>
            </div>
          )}
          {tableLabelActionBtnVisibility && (
            <img
              src={`/oo/assets/icon/${showTableContent ? 'minus-icon' : 'plus'}.svg`}
              className="Table_Action_Icon"
              alt="Action"
              onClick={() => {
                setshowTableContent(!showTableContent);
              }}
            />
          )}
        </div>
      )}
      {((tableLabelActionBtnVisibility && showTableContent) || !tableLabelActionBtnVisibility) && (
        <>
          {data?.length ? (
            <div className="Table_Container">
              <div className="Table_Header">
                {tableColumnTitle?.map((item: string) => <span key={item}>{item}</span>)}
              </div>
              <div className="Table_Body">
                {data?.map((item: any) => {
                  const docDateTime =
                    (item?.createdDateTime && getFormatedDateTime(item?.createdDateTime)) || '';
                  return (
                    <div
                      className="Table_Row"
                      key={
                        item?.commodityDesc + item?.packagingType ||
                        item?.type + item?.value ||
                        item?.displayName
                      }
                      onClick={() => {
                        callback && callback(item);
                      }}
                    >
                      <span>{item?.commodityDesc || item?.type || item?.displayName}</span>
                      <span>{item?.packagingType || item?.value || docDateTime}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="No_Data">No data available.</div>
          )}
          {link && (
            <span className="footer">
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-table-link"
              >
                <img src="/oo/assets/icon/submit-file.svg" alt="No Data" /> Request a Reference
              </a>
            </span>
          )}
        </>
      )}
    </div>
  );
};
export default CustomTable;
